import { useState, useEffect } from "react";

import DatePickerItem from "./DatePickerItem";

const DatePicker = (props) => {
  const [value, setValue] = useState(props.value);
  
  const { value: propsValue } = props;
  useEffect(() => {
    setValue(propsValue);
  }, [propsValue])

  const handleFinishBtnClick = () => {
    props.onSelect(value);
  };

  const handleDateSelect = (val, type) => {
    let transformed = value.split(" ");
    if (type === "sphere") transformed[0] = val;
    if (type === "cylinder") transformed[1] = val;
    if (type === "count") transformed[2] = val;
    transformed = transformed.join(" ");
    setValue(transformed);
  };
  const {
    theme,
    dateConfig,
    confirmText,
    cancelText,
    showHeader,
    showFooter,
    showCaption,
  } = props;

  const sphereCylinder = value.split(' ');
  return (
    <div className={`datepicker ${theme} ${props.isOpen ? 'show' : ''}`}>
      {showHeader && <div className="datepicker-header">{sphereCylinder[0] + ' ' + sphereCylinder[1]}</div>}
      {showCaption && (
        <div className="datepicker-caption">
          {dateConfig.map((item, index) => (
            <div key={index} className="datepicker-caption-item">
              {item.caption}
            </div>
          ))}
        </div>
      )}
      <div className="datepicker-content">
        {dateConfig.map((item, index) => (
          <DatePickerItem
            key={index}
            value={value}
            step={item.step}
            type={item.type}
            format={item.format}
            onSelect={handleDateSelect}
          />
        ))}
      </div>
      {showFooter && (
        <div className="datepicker-navbar">
          <button
            className="datepicker-navbar-btn"
            onClick={handleFinishBtnClick}
          >
            {confirmText}
          </button>
          <button className="datepicker-navbar-btn" onClick={props.onCancel}>
            {cancelText}
          </button>
        </div>
      )}
    </div>
  );
};

export default DatePicker;
